import { MenuItem, Select, type SelectChangeEvent } from '@mui/material';
import { useLanguage } from '@/i18n/LanguageContext';
import { SUPPORTED_LANGUAGES } from '@/i18n/uiStrings';
import type { Locale } from '@/types/api.types';

export function LanguageSelector({ light }: { light?: boolean }) {
  const { lang, setLang, ui } = useLanguage();
  return (
    <Select
      size="small"
      value={lang}
      onChange={(e: SelectChangeEvent) => setLang(e.target.value as Locale)}
      inputProps={{ 'aria-label': ui('app.language') }}
      sx={
        light
          ? {
              color: '#fff',
              minHeight: 36,
              '.MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(255,255,255,0.5)' },
              '.MuiSvgIcon-root': { color: '#fff' },
              '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#fff' },
            }
          : { minHeight: 36 }
      }
    >
      {SUPPORTED_LANGUAGES.map((l) => (
        <MenuItem key={l.code} value={l.code}>
          {l.nativeName}
        </MenuItem>
      ))}
    </Select>
  );
}
